import React from 'react';

export const FacebookIcon = ({ className, title }) => (
  <svg className={className} width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <path d="M13 25.1367C19.6274 25.1367 25 19.7641 25 13.1367C25 6.5093 19.6274 1.13672 13 1.13672C6.37258 1.13672 1 6.5093 1 13.1367C1 19.7641 6.37258 25.1367 13 25.1367Z" stroke="#222222"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M15.9452 13.8357L16.275 11.6804H14.2124V10.2817C14.2124 9.69206 14.5005 9.1173 15.4243 9.1173H16.3621V7.28235C16.3621 7.28235 15.511 7.13672 14.6974 7.13672C12.9986 7.13672 11.8883 8.16895 11.8883 10.0377V11.6804H10V13.8357H11.8883V19.0461C12.2669 19.1057 12.655 19.1367 13.0503 19.1367C13.4457 19.1367 13.8337 19.1057 14.2124 19.0461V13.8357H15.9452Z" fill="#222222"/>
  </svg>
);
